<template>
  <div class="player">
    <div class="embed-responsive embed-responsive-16by9 border" v-if="settings.mode == 'offline'">
      <div class="embed-responsive-item d-flex flex-column align-items-center justify-content-center offline">
        <div class="offline-content px-5 py-3 text-center">
          <h1 class="mx-0 mt-0 mb-4">Vi är inte live!</h1>
          <p class="m-0">
            Sändningen är över. :(
          </p>
        </div>
      </div>
    </div>
    
    <div class="embed-responsive embed-responsive-16by9 border" v-if="settings.mode == 'pre'">
      <div class="embed-responsive-item d-flex flex-column align-items-center justify-content-center">
        <h1 class="mx-0 mt-0 mb-4">Inte långt kvar nu!</h1>

        <vue-countdown :time="time" v-if="time && time > 0">
          <template slot-scope="props">
            <div class="h3 d-flex text-center">
              <div class="mr-3">{{ props.days }}<br><span class="small text-muted">{{ props.days == 1 ? "dag" : "dagar" }}</span></div>
              <div class="mr-3">{{ props.hours }}<br><span class="small text-muted">{{ props.hours == 1 ? "timme" : "timmar" }}</span></div>
              <div class="mr-3">{{ props.minutes }}<br><span class="small text-muted">{{ props.minutes == 1 ? "minut" : "minuter" }}</span></div>
              <div>{{ props.seconds }}<br><span class="small text-muted">{{ props.seconds == 1 ? "sekund" : "sekunder" }}</span></div>
            </div>
          </template>
        </vue-countdown>
      </div>
    </div>

    <div class="embed-responsive embed-responsive-16by9 border" v-if="settings.mode == 'live'">
      <div class="embed-responsive-item d-flex flex-column align-items-center justify-content-center">
        <jwplayer :stream-url="settings.streamUrl"></jwplayer>
      </div>
    </div>

    <div class="embed-responsive embed-responsive-16by9 border" v-if="settings.mode == 'post'">
      <div class="embed-responsive-item d-flex flex-column align-items-center justify-content-center">
        <h1 class="mx-0 mt-0 mb-4">Tack för att du kollade!</h1>
        <p class="m-0">
          Vi ses förhoppningsvis nästa gång.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  import VueCountdown from "@chenfengyuan/vue-countdown"
  import Jwplayer from "@/components/jwplayer"

  export default {
    name: "player",
    components: { VueCountdown, Jwplayer },
    props: {
      settings: {
        type: Object,
        default: () => ({ mode: "offline", startAt: null })
      }
    },
    data() {
      return {
        eventTimezone: "Europe/Stockholm",
        time: null,
      }
    },
    mounted() {
      if (this.settings.startAt) {
        let now = this.$DateTime.local().setZone(this.eventTimezone)
        let startAt = this.$DateTime.fromISO(this.settings.startAt, { zone: this.eventTimezone })
        let millis = startAt.diff(now).toObject()

        this.time = millis.milliseconds
      }
    }
  }
</script>